<template>
  <div class="m-md">
    <a @click="gotoProduct(product.id)" class="container--center product-block">
      <div v-if="isSpecial" class="specialBtn">special</div>
      <div v-if="isClearance" class="clearanceBtn">clearance</div>
      <div class="productImg"><img style="width: 100%;" :src="product.primaryImage.variants['256']"></div>
      <div class="product_description">
        <div class="nameFont">{{product.name}}sss</div>
        <!-- <small class="block modelFont text-ellipsis text-sm text-u-c ">{{product.model}}</small> -->

        <div class="product-current-price" v-if="product.price">
          RM {{priceFormat(product.discount_price ? product.discount_price : product.price)}}
          <!-- <span class="product-unit">{{product.unit_of_measure ? '/' + product.unit_of_measure : ''}}</span> -->
        </div>
        <div class="product-old-price" v-if="product.discount_price">
          <span class="product-old-price-number">RM {{priceFormat(product.price)}}</span>
          <span>({{calcOffDiscount(product.price, product.discount_price)}}
          % off)</span>
        </div>

      </div>
        
      
      
    </a>
  </div>
</template>

<script>
  export default {
    name: "product",
    props: {
      product: null
    },
    watch: {
      product: function (to) {
        this.product = to;
      }
    },
    methods: {
      calcOffDiscount(price, discount_price) {
        return 100 - Math.round((discount_price / price) * 100);
      },
      priceFormat(price) {
        return price.toLocaleString('en', { minimumFractionDigits: 2 });
      },
      gotoProduct(id) {
        window.location.assign('/ukuya/default/product#/' + id);
      },
      NameFormat(text){
        let res = text.substr(0, 80);
        if(text.length > 80) res += '...';
        return res;
      }
    },
    computed: {
      isSpecial() {
        const r = this.product.labels.find(label => label.type === 1);
        return r ? true : false;
      },
      isClearance() {
        const r = this.product.labels.find(label => label.type === 2);
        return r ? true : false;
      }
    }
  }
</script>

<style lang="scss">
  .lazy-image-placeholder {
    background-position: center center;
    background-repeat: no-repeat;
    background-size: auto;
  }
  .primary-image .lazy-img {
    width: 100% !important;
    max-width: 100% !important;
  }
  .products-grid {
    justify-content: center;
    display: flex;
    flex-wrap: wrap;
  }
  .product-block {
    position: relative;
    display: block;
    width: 200px;
    height: 317px;
    background-color: #fff;
    cursor: pointer;
    transition: all .2s;
    // &:hover {
    //   box-shadow: 0 5px 10px rgba(0,0,0,.1);
    // }
    
  }
  .specialBtn {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    background: #ff0221;
    border-radius: 0;
    font-weight: 700;
    font-size: 12px;
    text-align: center;
    color: #fff;
    width: 80px;
    height: 19px;
    text-transform: uppercase;
    z-index: 999;
    font-family: Roboto,"Helvetica Neue",Helvetica,Arial,sans-serif;
  }
  .clearanceBtn {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    background: #ff8002;
    border-radius: 0;
    font-weight: 700;
    font-size: 12px;
    text-align: center;
    color: #fff;
    width: 80px;
    height: 19px;
    text-transform: uppercase;
    z-index: 999;
    font-family: Roboto,"Helvetica Neue",Helvetica,Arial,sans-serif;
  }
  .productImg {
    margin: 0 auto;
    max-width: 100%;
  }
  .product_description {
    text-align: center;
    padding: 16px 5px 12px;
    font-family: Roboto,"Helvetica Neue",Helvetica,Arial,sans-serif;
  }
  .nameFont {
    color: #000;
    font-size: 16px;    
    padding-bottom: 11px;
    display: block;
    display: -webkit-box;
    max-width: 100%;
    height: 45px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;    
  }
  .modelFont {
    font-weight: 300;
    font-size: 12px;
    color: #888888;
  }
  .product-current-price {   
    font-size: 14px;
    color: #333;
  }
  // .product-unit {
  //   font-weight: 300;
  //   font-size: 11px;
  //   color: #888;
  // }
  .product-old-price {
    font-size: 12px;
    color: #6c757d;
    height: 18px;
  }
  .product-old-price-number {
    text-decoration: line-through;
  }
  @media (max-width: 767.98px) {
    .products-grid {
      align-items: start;
      justify-content: center;
      flex-direction: row;
    }
    .nameFont {
      font-size: 16px;
    }
    // .modelFont {
    //   font-weight: 300;
    //   font-size: 12px;
    //   color: #888888;
    // }
    .product-current-price {
      font-size: 14px;
      color: #333;
    }
    // .product-unit {
    //   font-weight: 300;
    //   font-size: 11px;
    //   color: #888;
    // }
    .product-old-price {
      font-size: 12px;
      color: #6c757d;
      height: 18px;
    }
  }

</style>
